export const SHOWMORE_TOGGLE = "SHOWMORE/SHOWMORE_TOGGLE";

export default (state = { isShowingMore: false }, { type, data }) => {
    switch (type) {
    case SHOWMORE_TOGGLE:
        return { isShowingMore: data.isNextStateShowing };
    default:
        return state;
    }
};

export const toggleShowMore = isNextStateShowing => ({
    type: SHOWMORE_TOGGLE,
    data: { isNextStateShowing },
});
